import { jsx } from 'react/jsx-runtime';
import { useReferenceSafeObject } from '@flex-design-system/fx-utils';
import { styled } from '@flex-design-system/stitches-react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { assignInlineVars } from '@vanilla-extract/dynamic';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { getColor } from '../../../../utils/colors.mjs';
import { tooltipContent, tooltipContentBackground } from './content.vanilla.mjs';

const TOOLTIP_CONTENT_DEFAULT_COLLISION_PADDING = { left: 16, right: 16 };
const TOOLTIP_CONTENT_DEFAULT_SIDE = "top";
const TOOLTIP_CONTENT_DEFAULT_SIDE_OFFSET = 4;
const TooltipContent = forwardRef(
  ({
    className: classNameFromProps,
    style: styleFromProps,
    color,
    portalContainer,
    prefersReducedMotion,
    ...props
  }, forwardedRef) => {
    const style = useReferenceSafeObject(styleFromProps);
    const className = classNames(
      tooltipContent({ prefersReducedMotion }),
      classNameFromProps
    );
    const styles = Object.assign(
      {},
      assignInlineVars({
        [tooltipContentBackground]: color !== void 0 ? getColor(color) : null
      }),
      style
    );
    return /* @__PURE__ */ jsx(TooltipPrimitive.Portal, { container: portalContainer, children: /* @__PURE__ */ jsx(
      StyledTooltipContent,
      {
        "data-scope": "tooltip",
        "data-part": "content",
        className,
        collisionPadding: TOOLTIP_CONTENT_DEFAULT_COLLISION_PADDING,
        side: TOOLTIP_CONTENT_DEFAULT_SIDE,
        sideOffset: TOOLTIP_CONTENT_DEFAULT_SIDE_OFFSET,
        style: styles,
        ref: forwardedRef,
        ...props
      }
    ) });
  }
);
const StyledTooltipContent = styled(TooltipPrimitive.Content);
TooltipContent.displayName = "Tooltip.Content";

export { TooltipContent };
//# sourceMappingURL=Content.mjs.map
